import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
    midsession : [],
    loading : false,
    error : null,
};

const midsessionSlice = createSlice({
    name:"midsession",
    initialState,
    reducers: {
        fetchMidsessionSuccess: (state,action) => {
            state.loading = false;
            state.midsession = action.payload;
        },
        fetchMidsessionFailure: (state,action) => {
            state.loading = false;
            state.error = action.payload
        }
    },
})

export const {
    fetchMidsessionSuccess,
    fetchMidsessionFailure
} = midsessionSlice.actions

export default midsessionSlice.reducer